import React from 'react';
import { FormField } from './FormField';
import { SchemaField, FormData, FormErrors } from './types';

interface ContactSectionProps {
  fields: SchemaField[];
  formData: FormData;
  errors: FormErrors;
  getDisplayValue: (field: SchemaField) => string;
  getInputClass: (fieldName: string, baseClass?: string) => string;
  handleChange: (name: string, value: string | boolean) => void;
  handleArrayChange: (name: string, idx: number, value: string) => void;
  addArrayItem: (name: string) => void;
  removeArrayItem: (name: string, idx: number) => void;
}

export function ContactSection({
  fields,
  formData,
  errors,
  getDisplayValue,
  getInputClass,
  handleChange,
  handleArrayChange,
  addArrayItem,
  removeArrayItem,
}: ContactSectionProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fields.map(field => (
          <div
            key={field.name}
            className={
              field.type === 'select' && field.name === 'pillar'
                ? 'md:col-span-2'
                : ''
            }
          >
            <FormField
              field={field}
              formData={formData}
              errors={errors}
              textareaMinHeight="min-h-[100px]"
              getDisplayValue={getDisplayValue}
              getInputClass={getInputClass}
              handleChange={handleChange}
              handleArrayChange={handleArrayChange}
              addArrayItem={addArrayItem}
              removeArrayItem={removeArrayItem}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
